module.exports = __webpack_public_path__ + "img/para.98d8dae7.jpg";